import { Badge, Form, Popover, Select, Spin } from "antd";
import React, { useEffect, useRef, useState, useMemo } from "react";
import styles from "./index.module.css";
import CurrentStage from "BorrowerStageStatus/NonHeader/CurrentStage";
import CurrentStatus from "BorrowerStageStatus/NonHeader/CurrentStatus";
import UpdateLoanModal from "../UpdateLoanStatus";

export const getStatusJson = (status, stage, isOpenUpdateModal) => {
  const isClose =
    status === "LoanFunded" && stage === "Closing" && isOpenUpdateModal;
  const isDisposed =
    ["ApprovedButNotAccepted", "Withdrawn", "Denied", "Other", "ClosedForIncompleteness", "PreApprovalRequestedDenied", "CounterOfferDenied"].includes(
      status
    ) && stage === "Disposed";
  return {
    hasUpdate: isClose,
    hasOpen: isClose || isDisposed,
  };
};
export const StageForm = ({
  stageName="currentStage",
  currentStage,
  loanID,
  formItemProps = {},
  isOpenUpdateModal = true,
  currentStatus,
  rowData = {},
  successFn = () => {},
  isChangeRedux = true, 
  isChangeDefaultStyle=true, //true修改样式
  ...props
}) => {
  return (
    
      <Form.Item name={stageName} {...formItemProps}>
        <CurrentStage
          currentStage={currentStage}
          loanID={loanID}
          boxClassName={isChangeDefaultStyle?styles.stageBox:''}
          wrapClassName={isChangeDefaultStyle?styles.stageWrap:''}
          {...props}
          onChange={(e) => {
            props?.onChange && props.onChange(e);
          }}
        />
      </Form.Item>
    
  );
};
export const StatusForm = ({
  statusName="currentStatus",
  currentStatus,
  currentStage,
  formItemProps = {},
  loanID,
  isOpenUpdateModal = true,
  rowData = {},
  successFn = () => {},
  isChangeRedux = true,
  isChangeDefaultStyle=true,
  ...props
}) => {
  const [openPortal, setOpenPortal] = useState(false);
  const [isUpdateLoan, setIsUpdateLoan] = useState(false);
  const [oldData, setOldData] = useState(''); //只有手动change才可以触发弹框,且只触发一次

  return (
    <>
      <Form.Item name={statusName} {...formItemProps}>
        <CurrentStatus
          currentStatus={currentStatus}
          currentStage={currentStage}
          loanID={loanID}
          boxClassName={isChangeDefaultStyle?styles.statusBox:''}
          wrapClassName={isChangeDefaultStyle?styles.statusWrap:''}
          {...props}
          onChange={(e, isFirst) => {
            props?.onChange && props.onChange(e);
            const { hasOpen, hasUpdate } = getStatusJson(
              e,
              currentStage,
              false
            );
            setIsUpdateLoan(hasUpdate);
            if (oldData === e) return;
            if (hasOpen && !isFirst) {
              setOpenPortal(true);
              setOldData(e);
            }else{
              setOldData('');
            }
          }}
        />
      </Form.Item>
      <UpdateLoanModal
        onCancel={() => {
          setOpenPortal(false);
        }}
        open={openPortal}
        loanId={loanID}
        rowData={rowData}
        isUpdateLoan={isUpdateLoan}
        successFn={successFn}
        isChangeRedux={isChangeRedux}
      />
    </>
  );
};

const StageStatusForm = ({
  currentStage,
  currentStatus,
  loanID,
  statusName = "currentStatus",
  stageName = "currentStage",
  stageFormItemProps = {},
  statusFormItemProps = {},
  stageProps = {},
  statusProps = {},
  isOpenUpdateModal = true, //状态改变是否触发disposition update弹框
  rowData = {}, //初始化disposition update预展示的值
  successFn = () => {}, //disposition update弹框保存成功后触发
  isChangeRedux = true, //ture通过redux修改值，false通过loanId请求接口改变disposition update弹框内的
  isChangeDefaultStyle=true,
  style={}
}) => {
  return (
    <div className={styles.stageStatus} style={style}>
      <StageForm
        currentStage={currentStage}
        currentStatus={currentStatus}
        loanID={loanID}
        stageName={stageName}
        formItemProps={stageFormItemProps}
        isOpenUpdateModal={isOpenUpdateModal}
        rowData={rowData}
        successFn={successFn}
        isChangeRedux={isChangeRedux}
        isChangeDefaultStyle={isChangeDefaultStyle}
        {...stageProps}
      />
      <StatusForm
        currentStage={currentStage}
        currentStatus={currentStatus}
        loanID={loanID}
        statusName={statusName}
        formItemProps={statusFormItemProps}
        isOpenUpdateModal={isOpenUpdateModal}
        rowData={rowData}
        successFn={successFn}
        isChangeRedux={isChangeRedux}
        isChangeDefaultStyle={isChangeDefaultStyle}
        {...statusProps}
      />
    </div>
  );
};
export default StageStatusForm;
